import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import DocumentRepositoryLoanListSF from '../../../components/superUser/loan/DocumentRepositoryLoanListSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'

const DocumentRepositoryLoanListPageUI = ({ context, account, errorList, loanList, onRefreshClick,
  onDownloadAllClick, downloadingAll }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_feas' backLink='/su/documentRepository'
    headerText={account && account.accountName} dimension='w768'
    centered={!loanList} account={account} page='documentRepository'
  >
    {
      !loanList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loanList && loanList.length > 0 &&
   <DocumentRepositoryLoanListSF
        context={context}
        loanList={loanList}
        onRefreshClick={onRefreshClick}
        onDownloadAllClick={onDownloadAllClick}
        downloadingAll={downloadingAll}
      />
    }
    {
      loanList && loanList.length === 0 &&
      <div>
        <span className='g_flex_h g_flex_left'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
<span className='g_m_left_100 g_large'><b>Document Repository</b></span>
        </span>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No loans yet'
        />
      </div>
    }
  </SuperUserAccountPageUI>

export default DocumentRepositoryLoanListPageUI

